import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CountrySettingService } from 'src/app/core/countries-managment/country-settings.service';
import { TableColumn, TableComponent } from '../shared/table/table.component';
import { CompaniesTable } from './company-list';
import { CompanyListService } from './company-list.service';
import { ConfirmationModalComponent } from '../shared/confirmation-modal/confirmation-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { RestService } from 'src/app/core/services/rest.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.scss'],
})
export class CompanyListComponent implements OnInit, AfterViewInit {
  constructor(
    private companyListService: CompanyListService,
    private countrySettingService: CountrySettingService,
    private ref: ChangeDetectorRef,
    private dialog: MatDialog,
    private translate: TranslateService,
    private router: Router,
    private snackbar: MatSnackBar
  ) { }

  @ViewChild(TableComponent) tableComponent: TableComponent;
  dataSource;
  total;
  columns: TableColumn[];
  isLoading;
  users;
  size = 5;
  page = 1;
  selectedUsers = '';
  search = '';
  active = null;
  verified = -1;
  orderBy = -1;
  asc = -1;
  interval;

  ngOnInit(): void {
    this.columns = CompaniesTable;
    this.getCompaniesList();
    this.users = this.companyListService.getUsersList();
  }

  searchCompany(text) {
    if (this.interval) clearTimeout(this.interval);
    this.search = text;
    this.interval = setTimeout(() => {
      this.getCompaniesList();
    }, 800);
  }

  selectedUser(users) {
    this.selectedUsers = users.join(',');
    this.getCompaniesList();
  }

  selectedStatus(event) {
    if (event < 2) {
      this.active = event;
    }
    else {
      this.active = null;
    }
    this.getCompaniesList();
  }

  selectedVerified(event) {
    if (event < 2) {
      this.verified = event;
    }
    else {
      this.verified = -1;
    }
    this.getCompaniesList();
  }

  getCompaniesByPaginator(index, size) {
    this.size = size;
    this.page = index;
    this.getCompaniesList();
  }

  ngAfterViewInit(): void {
    this.tableComponent.setOrderFirst('COMPANY_LIST.COMPANY_NAME');
  }

  getCompaniesList() {
    this.isLoading = true;
    this.companyListService
      .getCompaniesList(this.page, this.size, this.search, this.selectedUsers, this.active, 
        this.verified, this.orderBy, this.asc)
      .subscribe((res) => {
        this.dataSource = res.result;
        this.total = res.total;
        this.ref.markForCheck();
        this.isLoading = false;
      });
  }

  selectedCompany(company) {
    if (company.action === 'toggleFavorite') {
      company.payload.following = !company.payload.following;
      this.companyListService.updateFavorite(company.payload.id).subscribe();
    }
    if (company.action === 'navigate') {
      this.countrySettingService.setCurrentCountryID(
        company.payload.country_id
      );
      this.router.navigate(['/company/' + company.payload.id]);
    }
    if (company.action === 'active') {
      this.statusCompany(company, true);
    }
    if (company.action === 'inactive') {
      this.statusCompany(company, false);
    }
    if (company.action === 'delete') {
      this.deleteCompany(company);
    }
  }

  deleteCompany(company) {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: {
        text: `${this.translate.instant('MESSAGES.DELETE_COMP_QUESTION')}`,
        type: 'yesorno',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        return this.companyListService.deleteCompany(company.payload.id).subscribe(response => {
          if (response.success) {
            this.snackbar.open('Sociedad eliminada', 'close', {
              duration: 1500,
            });
            this.getCompaniesList();
          }
          else {
            this.snackbar.open('Hubo un error eliminando la sociedad', 'close', {
              duration: 1500,
            });
          }
        });
      }
      else {
        dialogRef.close();
      }
    });
  }

  statusCompany(company, active) {
    let message = (active) ? `${this.translate.instant('MESSAGES.ACTIVE_QUESTION')}` : `${this.translate.instant('MESSAGES.INACTIVE_QUESTION')}`;
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: {
        text: message,
        type: 'yesorno',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        return this.companyListService.statusCompany(company.payload.id, active).subscribe(response => {
          if (response.success) {
            this.snackbar.open('Sociedad actualizada correctamente', 'close', {
              duration: 1500,
            });
            this.getCompaniesList();
          }
          else {
            this.snackbar.open('Hubo un error actualizando la sociedad', 'close', {
              duration: 1500,
            });
          }
        });
      }
      else {
        dialogRef.close();
      }
    });
  }

  orderByCol(e) {
    switch (e.action) {
      case 'COMPANY_LIST.COMPANY_NAME':
        this.orderBy = 1;
        this.asc = (e.orderDesc) ? 0 : 1;
        this.getCompaniesList();
        break;
      case 'COMPANY_LIST.LAST_VALIDATION':
        this.orderBy = 0;
        this.asc = (e.orderDesc) ? 0 : 1;
        this.getCompaniesList();
        break;
      default:
        break;
    }
  }

}
